import type { Location } from '@remix-run/react';
import { PAGE_KEY } from '../config/url-page-keys';

export const trimPaginationURL = (
    page: number | null,
    searchParams: URLSearchParams,
    location: Location
): string => {
    const copyParams = new URLSearchParams(searchParams);
    if (page && page > 1) {
        copyParams.set(PAGE_KEY, page.toString());
    } else {
        copyParams.delete(PAGE_KEY);
    }
    return `${location.pathname}?${copyParams.toString()}`;
};
